<div
  class="please-wait-card"
  role="status"
  aria-live="polite"
  aria-busy="true">
  <div class="please-wait-card__icon" aria-hidden="true">
    <svg
      class="please-wait-card__svg"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true">
      <path
        d="M12 2V6M16.2 7.7999L19.1 4.8999M22 12H18M16.2 16.2L19.1 19.1M12 18V22M7.8 16.2L4.9 19.1M2 12H6M7.8 7.8L4.9 4.9"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"/>
    </svg>
  </div>

  <div class="please-wait-card__copy">
    <h2 class="please-wait-card__title">
      {{ title || (titleKey | translate) }}
    </h2>
    <p class="please-wait-card__message">
      {{ subtitle || (subtitleKey | translate) }}
    </p>
  </div>

  <div class="please-wait-card__dots" aria-hidden="true">
    <span class="please-wait-card__dot please-wait-card__dot--pill"></span>
    <span class="please-wait-card__dot please-wait-card__dot--md"></span>
    <span class="please-wait-card__dot please-wait-card__dot--sm"></span>
  </div>

  <div class="please-wait-card__footer" *ngIf="showFooter">
    <p>
      {{ 'auth.PoweredBy' | translate }}
      <a [href]="portalUrl" target="_blank" rel="noopener">ZUMConnect</a>
    </p>
  </div>
</div>
